module.exports = __webpack_public_path__ + "img/喇叭.4deb7e73.png";